const getters = {
    getBackPage: state => state.backPage,
    getCallNumber: state => state.callNumber,
}




export default getters;
